(function () {
  'use strict';

  var conversionLabels = {
    '7652315070': 'AW-11373062237/2GS4CKruo-gcEN3QjK8q',
    '7657911130': 'AW-11373062237/2GS4CKruo-gcEN3QjK8q',
    '3174929726': 'AW-11373062237/Tw2iCK3uo-gcEN3QjK8q'
  };

  document.addEventListener('click', function (event) {
    var target = event.target;
    var anchor = target && target.closest ? target.closest('a[href^="tel:"]') : null;
    if (!anchor) return;

    var digits = (anchor.getAttribute('href') || '').replace(/\D/g, '').slice(-10);
    var sendTo = conversionLabels[digits];

    if (sendTo && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', { send_to: sendTo });
    }
  }, true);
})();
